import(/* webpackMode: "eager", webpackExports: ["CookieModal"] */ "/home/runner/work/pos-ui/pos-ui/components/CookiePolicy/CookieModal.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/components/CountryRedirectionModal/CountryRedirectionModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/home/runner/work/pos-ui/pos-ui/components/DatadogInit.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/components/LayoutWrapper/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/components/PageTrackLoader/PageTrackLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/home/runner/work/pos-ui/pos-ui/components/Toast/ToastContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/home/runner/work/pos-ui/pos-ui/contexts/cartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/home/runner/work/pos-ui/pos-ui/contexts/sessionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/home/runner/work/pos-ui/pos-ui/contexts/toastContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/home/runner/work/pos-ui/pos-ui/modules/query/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZendeskProvider"] */ "/home/runner/work/pos-ui/pos-ui/modules/support/ZendeskProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/modules/theme/StyledSheetManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/pos-ui/pos-ui/modules/theme/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\",\"800\",\"900\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/nuqs/dist/adapters/next/app.js");
